import { useMemo } from 'react';


export const useApiBaseUrl = (appUrl) => {
  const apiBaseUrl = useMemo(() => {
    const appName = localStorage.getItem("appName");
    const network = localStorage.getItem("network");
    const collabType = localStorage.getItem("collabType");
    const roleName = localStorage.getItem("roleName");

    if (appName && network && collabType && roleName) {
      return `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;
    }
    return null;
  }, [
    appUrl,
    localStorage.getItem("appName"),
    localStorage.getItem("network"),
    localStorage.getItem("collabType"),
    localStorage.getItem("roleName"),
  ]);

  return apiBaseUrl;
};


// Default export for backward compatibility
export default {
  useApiBaseUrl
}; 